// Role-colored badge to indicate who sourced the application
const SOURCE_STYLES = {
  borrower: { bg: "bg-blue-50", text: "text-blue-700", ring: "border-blue-200", label: "Borrower" },
  dealer: { bg: "bg-amber-50", text: "text-amber-800", ring: "border-amber-200", label: "Dealer" },
  dsa: { bg: "bg-purple-50", text: "text-purple-700", ring: "border-purple-200", label: "DSA" },
  admin: { bg: "bg-slate-100", text: "text-slate-700", ring: "border-slate-300", label: "Admin" },
  underwriter: { bg: "bg-teal-50", text: "text-teal-700", ring: "border-teal-200", label: "Underwriter" },
  operations: { bg: "bg-emerald-50", text: "text-emerald-700", ring: "border-emerald-200", label: "Operations" },
  collections: { bg: "bg-rose-50", text: "text-rose-700", ring: "border-rose-200", label: "Collections" },
};

export default function SourceBadge({ source, className = "" }) {
  const key = (source || "").toLowerCase();
  const s = SOURCE_STYLES[key] || SOURCE_STYLES.admin;
  return (
    <span
      data-testid={`source-badge-${key}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border ${s.bg} ${s.text} ${s.ring} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${s.text.replace("text-", "bg-")}`} />
      {s.label}
    </span>
  );
}
